<template>
        <div class="warp">
            <!-- 表单 -->
            <div class="box">
               <div class="forms">
                <div class="child">
                    <div class="name"><span>*</span>原密码：</div>
                    <div class="content"><el-input v-model="sendInfo.name1"></el-input></div>
                </div>
                <div class="error" v-if="errors['sendInfo.name1']">错误提示：{{errors['sendInfo.name1']}}</div>
                <div class="child">
                    <div class="name"><span>*</span>新密码：</div>
                    <div class="content"><el-input v-model="sendInfo.name2"></el-input></div>
                </div>
                <div class="hint">由字母、数字、字符组成，6-20位，区分大小写</div>
                <div class="error" v-if="errors['sendInfo.name2']">错误提示：{{errors['sendInfo.name2']}}</div>
                <div class="child">
                    <div class="name"><span>*</span>重新输入密码：</div>
                    <div class="content"><el-input v-model="sendInfo.name3"></el-input></div>
                </div>
                <div class="error" v-if="errors['sendInfo.name3']">错误提示：{{errors['sendInfo.name3']}}</div>
                <div class="child">
                    <div class="name"></div>
                    <div class="content">
                      <div class="doubleBtn">
                        <el-button size="small" type="primary" @click="submit">保存</el-button>
                        <el-button size="small" @click="cancel">取消</el-button>
                    </div>
                    </div>
                </div>
                
            </div>
            </div>
        </div>
</template>

<script>
// import breadcrumb from '../../components/breadcrumb';
import upLoad from '../../components/upLoad'
import {getDict} from "@/axios";
export default {
    components:{
        // breadcrumb,
        upLoad
    },
    data(){
        return{
           sendInfo:{//提交密码的表单信息
                name1:'',//原密码
                name2:'',//新密码
                name3:'',//重新输入密码
            },
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        },
        username(){
            return this.$store.state.user.username
        }
    },
    vuerify: {
        'sendInfo.name1':'password',
        'sendInfo.name2':'password',
        'sendInfo.name3':{
            test:function(){
                if(this.sendInfo.name2!=this.sendInfo.name3){
                    return false;
                }else{
                    return true;
                }
            },
            message:'两次密码不一致'
        },
    },
	created() {
		this.isShow()
		
	},
    methods:{
		isShow(){
            this.sendInfo = {
                name1:'',//原密码
                name2:'',//新密码
                name3:'',//重新输入密码
            }
            this.$vuerify.clear();
        },
        //取消按钮
        cancel:function(){
            this.$router.back(-1)
        },
        //保存按钮
        submit:function(){
            this.$vuerify.clear();
            if(this.$vuerify.check()){
                let datas = this.sendInfo
                let sendInfo = {
                    originalPassword:datas.name1,
                    newPassword:datas.name2,
                    confirmPassword:datas.name3
                }
                this.$axiosz.put('/backstage/sysUser/password/', this.$qs.stringify(sendInfo)).then((r) => {
                    if (r.code == 200) {
                        this.$message({
                            type: 'success',
                            message: '操作成功!'
                        });
                        this.$router.back(-1)
                    } else {
                        this.$alert(r.msg)
                    }
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.warp{
     height:96%;
     overflow-x: hidden;
     overflow-y: auto;
    .box{
        padding-top: 20px;
        border-top:1px solid rgba(112, 112, 112, 0.1);
        .forms{
            max-width: 650px;
            margin: auto;
            padding-top:100px;
            .child{
                .content{
                    flex: 1;
					.el-textarea{
						width: 100% !important;
					}
                }
				/deep/ .el-select{
					width: 100% !important;
				}
				
				.name{
					width: 150px !important;
					text-align: right;
				}
            }
			.hint{
				padding-left: 100px;
			}
			.singleBtn{
				text-align: center;
			}
			.error{
				padding-left: 100px;
			}
        }
    }
}
</style>